module.exports = __webpack_public_path__ + "static/media/chevron-down.4d3e9502.svg";